import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import {BrowserRouter as Router, Route,Routes, useLocation} from 'react-router-dom'
import './App.css';
import getImageLinks from './Services/getImageLinks.js';
import intervalManager from './Utilities/intervalManager.js';
import Home from './Pages/Home.js';
import StoryBoardPage from './Pages/StoryBoardPage.js';
import ShotListPage from './Pages/ShotListBuilder/ShotListPage.js';
import CharacterCreationPage from './Pages/CharacterCreationPage.js';
import getImageLinksCharacters from './Services/getImageLinksCharacters.js';
import handleUpdateCharacterPreview from './Utilities/handleUpdateCharacterPreview.js';
import ResetPasswordPage from './Pages/ResetPasswordPage.js';
import { CharacterContext } from './Contexts/CharacterContext.js';
import { StoryboardStateContext } from './Contexts/StoryboardStateContext.js';
import { CharacterCreatorStateContext } from './Contexts/CharacterCreatorStateContext.js';
import { AuthContext } from './Contexts/AuthContext.js';
import { UserContext } from './Contexts/UserContext.js';
import { ImageIndexContext } from './Contexts/ImageIndexContext.js';
import { IsDisabledContext } from './Contexts/IsDisabledContext.js';
import { RFPBuilderPage } from './Pages/RFPBuilder/RFPBuilderPage.js';
import { Masthead } from '@nxtvid/component-library';
import signOut from './Services/signOut.js';
import { SignUpInfoContext } from './Contexts/SignUpInfoContext.js';
import { newRegistration } from './Services/newRegistration.js';
import { signIn } from './Services/signIn.js';
import { resetPassword } from './Services/resetPassword.js';
import { MastheadRefContext } from './Contexts/MastheadRefContext.js';
import { StoryboardsContext } from './Contexts/StoryboardsContext.js';
import { useSocket } from './Contexts/WebSocketContext';
import Inbox from './Pages/Inbox/Inbox.js';
import CheckOutSuccess from './Pages/CheckOutSuccess/CheckOutSuccess.js';
import CheckOutCancel from './Pages/CheckOutCancel/CheckOutCancel.js';
import StripeOnboardingComplete from './Pages/StripeOnboardingComplete/StripeOnboardingComplete.js';
import StripeOnboardingRefresh from './Pages/StripeOnboardingRefresh/StripeOnboardingRefresh.js';

const LocationListener = ({ setLocation }) =>{
  const currentLocation = useLocation();
  

  useEffect(()=>{

    setLocation(currentLocation.pathname);
  }, [currentLocation, setLocation])

  return null;
}

const changeImages = ({image, index, storyboardState, setStoryboardState}) =>{
  const tempStoryboardState = {...storyboardState}
  tempStoryboardState.storyboard[index].image = image
  setStoryboardState(tempStoryboardState)
}

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};



function App() {;
  const [location, setLocation] = useState(window.location.pathname)
  const {isAuthenticated, setIsAuthenticated} = useContext(AuthContext)
  const {userInfo, setUserInfo} = useContext(UserContext)
  const {setCharacters} = useContext(CharacterContext) 
  const {characterCreatorState, setCharacterCreatorState} = useContext(CharacterCreatorStateContext)
  const {storyboardState, setStoryboardState} = useContext(StoryboardStateContext)
  const {storyboards, setStoryboards} = useContext(StoryboardsContext)
  const {imageIndex} = useContext(ImageIndexContext)
  const {setIsDisabled} = useContext(IsDisabledContext)
  const {signUpInfo, setSignUpInfo} = useContext(SignUpInfoContext)
  const {mastheadRef} = useContext(MastheadRefContext)
  const {socket, totalUnreadCount} = useSocket();

  

  useEffect(()=>{
    
      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
      fetch(`${API_BASE_URL}/api/validate-token`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
        },
      })
        .then(response => response.json())
        .then(data => {
      
          setIsAuthenticated(data.isValid); // Update state based on response
         
          
          setCharacters(data.characters)
        })
        .catch(error => {
          console.error('Error validating token:', error);
          setIsAuthenticated(false); // Set to false if there's an error
        });
        fetch(`${API_BASE_URL}/api/getUserInfo`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
          },
        })
          .then(response => response.json())
          .then(data => {
            setUserInfo(data)
          })
          .catch(error => {
            console.error('Error validating token:', error);
            setIsAuthenticated(false); // Set to false if there's an error
          });
    
  }, [])

  const reduceTokens = useCallback((purchase) =>{
    
    let amount = 0;
    if(purchase==='newCharacter'){
      amount = 1; 
    }
    else if(purchase === 'newStoryboardImage'){
      amount = 3
    }
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
    fetch(`${API_BASE_URL}/reduceTokens`,{
      method:'POST',
      headers:{
        'Content-Type': 'application/json',
        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
    },
      body:JSON.stringify({
        amount:amount,
        userInfo:userInfo,
      })
    })
    .then(res=>{
      return res.json();
    })
    .then(data=>{
      const tempUserInfo = {...userInfo}
      tempUserInfo.tokens = data.user.tokens
      setUserInfo(tempUserInfo)
    })

  },[userInfo])

  // This is where I keep watch for a websocket message. When they hit, i identify the current page, and replace the relevant image accordingly
  useEffect(() => {
    if (!socket) return;

      const debouncedOnMessage = debounce((event) => {
      
      if (location === "/Storyboard"){

        const receivedData = JSON.parse(event.data);
        const id = JSON.stringify(receivedData.data.object.id, null, 2)
        intervalManager.clearAllIntervals();
        getImageLinks(JSON.parse(id)).then(function(result){changeImages({image:result,index:imageIndex, storyboardState:storyboardState, setStoryboardState:setStoryboardState})});
        setIsDisabled(false)
        reduceTokens('newStoryboardImage')
      }
      else if(location === "/CharacterCreation"){

        const receivedData = JSON.parse(event.data);
        const id = JSON.stringify(receivedData.data.object.id, null, 2)
        intervalManager.clearAllIntervals();
        getImageLinksCharacters(JSON.parse(id)).then(function(result){handleUpdateCharacterPreview(result, characterCreatorState, setCharacterCreatorState)});
        setIsDisabled(false)
        reduceTokens('newCharacter')
      }
      
    }, 300);

    socket.addEventListener('message', debouncedOnMessage);
    return () => {
      if(socket){
        socket.removeEventListener('message', debouncedOnMessage);
      }
    };
  },[location,imageIndex, storyboardState, characterCreatorState, reduceTokens]);

  return (
    <Router>
      <LocationListener setLocation = {setLocation} />
      <Masthead ref={mastheadRef} isAuthenticated = {isAuthenticated} userInfo={userInfo} signOut = {signOut} site = 'app' signUpInfo = {signUpInfo} setSignUpInfo={setSignUpInfo} newRegistration = {(value)=>newRegistration(value)} signIn = {(value)=>signIn(value)} passwordReset = {(value)=>resetPassword(value)} inboxUnreadCount = {totalUnreadCount}/>
      <div id='modal-root'/>
      <Routes>
        <Route exact path ='/' element = {<Home/>}/>
        <Route path = '/Storyboard' element = {<StoryBoardPage/>}/>
        <Route path = '/CharacterCreation' element = {<CharacterCreationPage/>}/>
        <Route path = '/RFPBuilder' element = {<RFPBuilderPage/>}/>
        <Route path = '/ShotList' element = {<ShotListPage isAuthenticated={isAuthenticated} signUpInfo= {signUpInfo} setSignUpInfo = {setSignUpInfo} setIsAuthenticated = {setIsAuthenticated} userInfo = {userInfo} setUserInfo= {setUserInfo} projectState={storyboardState} setProjectState={setStoryboardState} projects={storyboards} setProjects={setStoryboards}/>}/>
        <Route path = '/Inbox' element = {<Inbox/>}/>
        <Route path = '/reset-password/:key' element={<ResetPasswordPage />}/>
        <Route path = '/checkout-success' element = {<CheckOutSuccess />}/>
        <Route path = '/checkout-cancel' element={<CheckOutCancel/>} />
        <Route path = '/stripe/onboarding/complete' element={<StripeOnboardingComplete/>}/>
        <Route path = '/stripe/onboarding/refresh' element={<StripeOnboardingRefresh/>}/>
      </Routes>
    </Router>
  );
}

export default App;
